var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentOpenImportable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.632 6.314C.73 6.314 0 7.044 0 7.946v11.422C0 20.27.78 21 1.682 21H17.75c1.401 0 2.281-2.21 2.253-2.42l-.422-.549V7.946c0-.902-.73-1.632-1.631-1.632z",
    fill: "#2980b9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3c-.901 0-2 1.099-2 2v10.928c0 1 .546 1.808 1.448 1.808H17.134c.901 0 1.632-.73 1.632-1.631V6.532C18.766 5.633 17.9 5 17 5H10.473L8 3z",
    fill: "#2980b9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.52 19.368L20 8c.118-.909-.203-2-1.203-2H4c-.901 0-1.42.229-1.557 1.13L1 19z",
    fill: "#bdc3c7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7c-.901 0-1.362.044-1.68.946L2.591 12.84l-.288.816L1 18c-.318.901 0 2 2 2h15.14c.902 0 1.34-.156 1.799-1.12l1.946-5.223.288-.816 1.463-4.32c.428-1.1.172-1.521-.972-1.521z",
    fill: "#3498db"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentOpenImportable);
export default __webpack_public_path__ + "static/media/document-open-importable.6c3a0b1ac216ce90b8d13517a8e56749.svg";
export { ForwardRef as ReactComponent };